import React, {Component} from 'react';

//import {connect} from "react-redux";

class CsodTableHeader extends Component {

    render() {
        const {rowItem} = this.props;
        //data-tag="ltlHeaderAction"
        return (
            <tr>
                {rowItem.map((i,index) => {
                    return (
                        <th key={index} className="col">
                            {i}
                        </th>
                    );
                })}
            </tr>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default CsodTableHeader;


// WEBPACK FOOTER //
// ./src/widgets/components/Csod/CsodTableHeader.js